export default __webpack_public_path__ + "static/media/mw_btn_org.880b8a10.png";